export default __webpack_public_path__ + "static/media/ellipse.17621332.svg";